<template>
  <div class="data-panel">
    <div class="data-panel-wrapper">
      <div class="part-one">
        <div class="height-full width-full flex flex-row">
          <div class="flex-1">
            <div class="width-full height-full flex flex-column">
              <div class="left-part-one section">
                <border-style>
                  <div class="relative">
                    <div class="absolute width-full height-full">
                      <div class="project-statistics flex flex-row">
                        <div class="flex-1 flex flex-row">
                          <div class="statistics-icon cyan">
                            <i class="r2-icon-project"></i>
                          </div>
                          <div class="flex-1">
                            <div class="statistics-number ellipsis">{{projectInfo.thisWeek}}</div>
                            <div class="statistics-type ellipsis">本周新增项目</div>
                          </div>
                        </div>
                        <div class="divide-line"></div>
                        <div class="flex-1 flex flex-row">
                          <div class="statistics-icon blue">
                            <i class="r2-icon-project"></i>
                          </div>
                          <div class="flex-1">
                            <div class="statistics-number ellipsis">{{projectInfo.progressing}}</div>
                            <div class="statistics-type ellipsis">在施项目</div>
                          </div>
                        </div>
                        <div class="divide-line"></div>
                        <div class="flex-1 flex flex-row">
                          <div class="statistics-icon blue">
                            <i class="r2-icon-project"></i>
                          </div>
                          <div class="flex-1">
                            <div class="statistics-number ellipsis">{{projectInfo.recorded}}</div>
                            <div class="statistics-type ellipsis">备案项目</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </border-style>
              </div>
              <div class="left-part-two section">
                <border-style>
                  <div class="width-full height-full flex flex-column">
                    <div class="section-title">在施项目阶段</div>
                    <div class="flex-1 relative">
                      <Echart id="project-manage-1" :style="{width: '100%', height: '100%'}"
                              :option="projectManage.option"
                              :key="progressingKey"></Echart>
                    </div>
                  </div>
                </border-style>
              </div>
              <div class="left-part-three section">
                <border-style class="flex flex-column">
                  <div class="width-full height-full flex flex-column">
                    <div class="section-title">已备案项目类型</div>
                    <div class="flex-1 relative">
                      <Echart id="project-manage-2" :style="{width: '100%', height: '100%'}"
                              :option="recordManage.option"
                              :key="recordedKey"></Echart>
                    </div>
                  </div>
                </border-style>
              </div>
            </div>
          </div>
          <div class="flex-1 padding-left-12">
            <div class="width-full height-full flex flex-column">
              <div class="center-part-one section">
                <!--v-loading="!isLogin" element-loading-background="rgba(0, 0, 0, 0.3)" element-loading-text="加载中..."-->
                <border-style>
                  <iframe @load="loadFrame(100118008, 1, $event)" :src="qydataUrl + '/zjy/charts/qyPriceMaterialSave.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                          height="100%"></iframe>
                  <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyPriceMaterialSave&_t=1'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                          <!--height="100%"></iframe>-->
                  <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
                </border-style>
              </div>
              <div class="center-part-two section">
                <border-style>
                  <iframe @load="loadFrame(100118008, 2, $event)" :src="qydataUrl + '/zjy/charts/qyPriceMaterialSaveType.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                          height="100%"></iframe>
                  <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyPriceMaterialSaveType&_t=2'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                          <!--height="100%"></iframe>-->
                  <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
                </border-style>
              </div>
            </div>
          </div>
          <div class="flex-1 padding-left-12">
            <div class="width-full height-full flex flex-column">
              <div class="right-part-one section">
                <border-style>
                  <iframe @load="loadFrame(100118008, 3, $event)" :src="qydataUrl + '/zjy/charts/qyZbStat.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                          height="100%"></iframe>
                  <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyZbStat&_t=3'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                          <!--height="100%"></iframe>-->
                  <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
                </border-style>
              </div>
              <div class="right-part-two section">
                <border-style>
                  <iframe @load="loadFrame(100118008, 4, $event)" :src="qydataUrl + '/zjy/charts/qyZbSotreTrend.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                          height="100%"></iframe>
                  <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyZbSotreTrend&_t=4'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                          <!--height="100%"></iframe>-->
                  <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
                </border-style>
              </div>
              <div class="right-part-three section">
                <border-style>
                  <iframe @load="loadFrame(100118008, 5, $event)" :src="qydataUrl + '/zjy/charts/qyZbProjectType.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                          height="100%"></iframe>
                  <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyZbProjectType&_t=5'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                          <!--height="100%"></iframe>-->
                  <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
                </border-style>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="part-two">
        <w-row class="height-full" :gutter="12" type="flex" justify="space-between">
          <w-col>
            <border-style>
              <iframe @load="loadFrame(100118008, 6, $event)" :src="qydataUrl + '/zjy/charts/qyPriceAccountSaveDistributed.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                      height="100%"></iframe>
              <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyPriceAccountSaveDistributed&_t=6'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                      <!--height="100%"></iframe>-->
              <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
            </border-style>
          </w-col>
          <w-col>
            <border-style>
              <iframe @load="loadFrame(100118008, 7, $event)" :src="qydataUrl + '/zjy/charts/qyPriceAccountApplicationDistributed.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                      height="100%"></iframe>
              <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyPriceAccountApplicationDistributed&_t=7'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                      <!--height="100%"></iframe>-->
              <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
            </border-style>
          </w-col>
          <w-col>
            <border-style>
              <iframe @load="loadFrame(100118008, 8, $event)" :src="qydataUrl + '/zjy/charts/qyZbAccountStore.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                      height="100%"></iframe>
              <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyZbAccountStore&_t=8'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                      <!--height="100%"></iframe>-->
              <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
            </border-style>
          </w-col>
          <w-col>
            <border-style>
              <iframe @load="loadFrame(100118008, 9, $event)" :src="qydataUrl + '/zjy/charts/qyZbAccountApplyProject.html'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"
                      height="100%"></iframe>
              <!--<iframe :src="qydataUrl + '/integration/indexChart?type=qyZbAccountApplyProject&_t=9'" frameborder="0" referrerpolicy="no-referrer" sandbox="allow-scripts allow-same-origin" width="100%" v-if="isLogin"-->
                      <!--height="100%"></iframe>-->
              <no-data :text="`${initial ? '请求异常，请重新登录' : '加载中'}`" :show-icon="false" v-else></no-data>
            </border-style>
          </w-col>
          <w-col>
            <border-style class="flex flex-column">
              <div class="section-title">全部数据库入口</div>
              <div class="flex-1 enter-wrapper">
                <w-row>
                  <template v-if="Array.isArray(applicationsMenus) && applicationsMenus.length && Array.isArray(applicationsMenus[0].childrenMenu)">
                    <w-col v-for="(menu, index) in applicationsMenus[0].childrenMenu" :key="menu.title" :span="8">
                      <div class="enter-box" @click="quickStart(menu, true, index)">
                        <div :class="['statistics-icon', colorMap[menu.icon]]">
                          <i :class="menu.icon"></i>
                        </div>
                        <div class="enter-text">{{menu.title}}</div>
                      </div>
                    </w-col>
                  </template>
                  <no-data v-else></no-data>
                </w-row>
              </div>
            </border-style>
          </w-col>
        </w-row>
      </div>
    </div>
  </div>
</template>

<script>
import {Echart} from '@/components/common'
import BorderStyle from './border-style'
import { mapState } from 'vuex'
// import { getCookie } from '@/assets/utils/CommonUtil'
import HomeService from '@/assets/service/home'
import {qydataUrl} from '@/assets/js/config'
import NoData from './no-data'

export default {
  name: 'dataPanel',
  components: {
    Echart,
    NoData,
    BorderStyle
  },
  computed: {
    ...mapState({
      // applicationPermission: state => state.menus.applicationPermission,
      applicationsMenus: state => state.menus.menuList.filter(item => (item.path === '/applications'))
    })
  },
  props: {
    initial: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    startTime: {
      type: Number
    }
  },
  data () {
    return {
      qydataUrl,
      projectInfo: {
        thisWeek: 0,
        progressing: 0,
        recorded: 0
      },
      progressingKey: `progressing-${Date.now()}`,
      recordedKey: `recorded-${Date.now()}`,
      projectManage: {
        option: {
          textStyle: {
            rich: {
              value: {
                color: '#FFFFFF',
                fontSize: 24,
                lineHeight: 24
              },
              name: {
                color: '#FFFFFF',
                fontSize: 14,
                lineHeight: 35
              }
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}\n{c}个'
          },
          color: ['#F96753', '#30BFF8', '#1F7BFF', '#16F1AE', '#234CAC', '#FFC51B', '#9E46CC', '#B1244C'],
          title: {
            text: ['{value|0}', '{name|总数}'].join('\n'),
            top: 'center',
            left: '175px',
            textAlign: 'center',
            textStyle: {
              rich: {
                value: {
                  color: '#FFFFFF',
                  fontSize: 24,
                  lineHeight: 32
                },
                name: {
                  color: 'rgba(255, 255, 255, 0.55)',
                  fontSize: 14,
                  lineHeight: 22
                }
              }
            }
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: '10%',
            top: 'center',
            icon: 'circle', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 8, // 设置间距
            textStyle: {
              // 文字样式
              color: '#FFFFFF',
              fontSize: '12'
            },
            formatter (name) {
              let target
              let data = [
                {value: 0, name: '评估阶段'},
                {value: 0, name: '招投标阶段'},
                {value: 0, name: '合同阶段'},
                {value: 0, name: '施工阶段'},
                {value: 0, name: '结算阶段'},
                {value: 0, name: '自定义项目'},
                {value: 0, name: '未启动阶段'}
              ]
              for (let i = 0, l = data.length; i < l; i++) {
                if (data[i].name === name) {
                  target = data[i].value
                }
              }
              return `${name}  ${target}个`
            }
          },
          series: [
            {
              name: '在施项目阶段',
              type: 'pie',
              radius: ['50%', '80%'],
              center: [180, '50%'],
              // stillShowZeroSum: false,
              avoidLabelOverlap: false,
              zlevel: 1,
              label: {
                show: false,
                formatter: '{d}%'
              },
              labelLine: {
                show: false
              },
              data: [
                {value: 0, name: '评估阶段'},
                {value: 0, name: '招投标阶段'},
                {value: 0, name: '合同阶段'},
                {value: 0, name: '施工阶段'},
                {value: 0, name: '结算阶段'},
                {value: 0, name: '自定义项目'},
                {value: 0, name: '未启动阶段'}
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      },
      recordManage: {
        option: {
          textStyle: {
            rich: {
              value: {
                color: '#FFFFFF',
                fontSize: 24,
                lineHeight: 24
              },
              name: {
                color: '#FFFFFF',
                fontSize: 14,
                lineHeight: 35
              }
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}\n{c}个'
          },
          color: ['#F96753', '#30BFF8', '#1F7BFF', '#16F1AE', '#234CAC', '#FFC51B', '#9E46CC', '#B1244C'],
          title: {
            text: ['{value|0}', '{name|总数}'].join('\n'),
            top: 'center',
            left: '175px',
            textAlign: 'center',
            textStyle: {
              rich: {
                value: {
                  color: '#FFFFFF',
                  fontSize: 24,
                  lineHeight: 32
                },
                name: {
                  color: 'rgba(255, 255, 255, 0.55)',
                  fontSize: 14,
                  lineHeight: 22
                }
              }
            }
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: '10%',
            top: 'center',
            icon: 'circle', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            itemGap: 8, // 设置间距
            textStyle: {
              // 文字样式
              color: '#FFFFFF',
              fontSize: '12'
            },
            formatter (name) {
              let target
              let data = [
                {value: 0, name: '未中标项目'},
                {value: 0, name: '中标项目'},
                {value: 0, name: '结算项目'},
                {value: 0, name: '评估项目'}
              ]
              for (let i = 0, l = data.length; i < l; i++) {
                if (data[i].name === name) {
                  target = data[i].value
                }
              }
              return `${name}  ${target}个`
            }
          },
          series: [
            {
              name: '已备案项目类型',
              type: 'pie',
              radius: ['50%', '80%'],
              center: [180, '50%'],
              // stillShowZeroSum: false,
              avoidLabelOverlap: false,
              zlevel: 1,
              label: {
                show: false,
                formatter: '{d}%'
              },
              labelLine: {
                show: false
              },
              data: [
                {value: 0, name: '未中标项目'},
                {value: 0, name: '中标项目'},
                {value: 0, name: '结算项目'},
                {value: 0, name: '评估项目'}
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      },
      frameLoaded: []
    }
  },
  mounted () {
    this.queryTotalData()
    this.queryProgressingData()
    this.queryRecordedData()
  },
  beforeDestroy () {
    let duration = Math.floor((Date.now() - this.startTime) / 1000)
    this.sentLog(100118001, {duration})
  },
  methods: {
    // iframe加载时间
    loadFrame (fnCode, name, event) {
      const dateNow = Date.now()
      this.sentLog(fnCode, {name, duration: ((dateNow - this.startTime) / 1000).toFixed(2)})
      this.frameLoaded.push(fnCode)
      if (this.frameLoaded.length === 9) {
        // 埋点：统计页面加载完成时间
        this.sentLog(100118009, {duration: ((dateNow - this.startTime) / 1000).toFixed(2)})
      }
    },
    // 查询项目总数
    queryTotalData () {
      HomeService.queryProjectNum({type: 'total'}).then(res => {
        if (res.code === 200) {
          const {thisWeek = 0, progressing = 0, recorded = 0} = res.data || {}
          Object.assign(this.projectInfo, {
            thisWeek,
            progressing,
            recorded
          })
        } else {
          this.projectInfo = {
            thisWeek: 0,
            progressing: 0,
            recorded: 0
          }
        }
      }).catch(() => {
        this.projectInfo = {
          thisWeek: 0,
          progressing: 0,
          recorded: 0
        }
      })
    },
    // 查询分阶段查询项目数量
    queryProgressingData () {
      HomeService.queryProjectNum({type: 'progressing'}).then(res => {
        if (res.code === 200) {
          const {
            evaluate = 0,
            bidding = 0,
            contract = 0,
            progressing = 0,
            settlement = 0,
            customize = 0,
            initial = 0
          } = res.data || {}
          let data = [
            {value: evaluate, name: '评估阶段'},
            {value: bidding, name: '招投标阶段'},
            {value: contract, name: '合同阶段'},
            {value: progressing, name: '施工阶段'},
            {value: settlement, name: '结算阶段'},
            {value: customize, name: '自定义项目'},
            {value: initial, name: '未启动阶段'}
          ]
          let total = evaluate + bidding + contract + progressing + settlement + customize + initial
          Object.assign(this.projectManage.option, {
            title: {
              text: ['{value|' + total + '}', '{name|总数}'].join('\n'),
              top: 'center',
              left: '175px',
              textAlign: 'center',
              textStyle: {
                rich: {
                  value: {
                    color: '#FFFFFF',
                    fontSize: 24,
                    lineHeight: 32
                  },
                  name: {
                    color: 'rgba(255, 255, 255, 0.55)',
                    fontSize: 14,
                    lineHeight: 22
                  }
                }
              }
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: '10%',
              top: 'center',
              icon: 'circle', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
              itemWidth: 10, // 设置宽度
              itemHeight: 10, // 设置高度
              itemGap: 8, // 设置间距
              textStyle: {
                // 文字样式
                color: '#FFFFFF',
                fontSize: '12'
              },
              formatter (name) {
                let target
                for (let i = 0, l = data.length; i < l; i++) {
                  if (data[i].name === name) {
                    target = data[i].value
                  }
                }
                return `${name}  ${target}个`
              }
            },
            series: [
              {
                name: '在施项目阶段',
                type: 'pie',
                radius: ['50%', '80%'],
                center: [180, '50%'],
                // stillShowZeroSum: false,
                avoidLabelOverlap: false,
                zlevel: 1,
                label: {
                  show: false,
                  formatter: '{d}%'
                },
                labelLine: {
                  show: false
                },
                data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          })
          this.progressingKey = `progressing-${Date.now()}`
        }
      }).catch(() => {
      })
    },
    // 查询备案项目数量
    queryRecordedData () {
      HomeService.queryProjectNum({type: 'recorded'}).then(res => {
        if (res.code === 200) {
          const {
            failBid = 0,
            bid = 0,
            settle = 0,
            evaluate = 0
          } = res.data || []
          let data = [
            {value: failBid, name: '未中标项目'},
            {value: bid, name: '中标项目'},
            {value: settle, name: '结算项目'},
            {value: evaluate, name: '评估项目'}
          ]
          let total = failBid + bid + settle + evaluate
          Object.assign(this.recordManage.option, {
            title: {
              text: ['{value|' + total + '}', '{name|总数}'].join('\n'),
              top: 'center',
              left: '175px',
              textAlign: 'center',
              textStyle: {
                rich: {
                  value: {
                    color: '#FFFFFF',
                    fontSize: 24,
                    lineHeight: 32
                  },
                  name: {
                    color: 'rgba(255, 255, 255, 0.55)',
                    fontSize: 14,
                    lineHeight: 22
                  }
                }
              }
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: '10%',
              top: 'center',
              icon: 'circle', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
              itemWidth: 10, // 设置宽度
              itemHeight: 10, // 设置高度
              itemGap: 8, // 设置间距
              textStyle: {
                // 文字样式
                color: '#FFFFFF',
                fontSize: '12'
              },
              formatter (name) {
                let target
                for (let i = 0, l = data.length; i < l; i++) {
                  if (data[i].name === name) {
                    target = data[i].value
                  }
                }
                return `${name}  ${target}个`
              }
            },
            series: [
              {
                name: '在施项目阶段',
                type: 'pie',
                radius: ['50%', '80%'],
                center: [180, '50%'],
                // stillShowZeroSum: false,
                avoidLabelOverlap: false,
                zlevel: 1,
                label: {
                  show: false,
                  formatter: '{d}%'
                },
                labelLine: {
                  show: false
                },
                data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          })
          this.recordedKey = `recorded-${Date.now()}`
        }
      }).catch(() => {
      })
    },
    // 点击快速入口
    quickStart (menu, isModule, index) {
      this.sentLog(100118002, {name: index + 1})
      this.switchModule(menu, isModule)
    }
  }
}
</script>

<style lang="less" scoped>
  .data-panel {
    width: 100%;
    height: 100%;
    position: relative;
    .data-panel-wrapper {
      width: 100%;
      height: 100%;
    }

    .section {
      padding-bottom: 12PX;
    }

    .section-title {
      padding: 12PX 24PX 0 24PX;
      height: 24PX;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 24PX;
    }

    .statistics-icon {
      width: 48PX;
      height: 48PX;
      margin: 7PX 20PX;
      border-radius: 50%;
      text-align: center;
      line-height: 46PX;

      i {
        font-size: 24PX !important;
      }

      &.cyan  {
        background: #29CBD1;
      }

      &.blue {
        background: #2079FA;
      }

      &.green {
        background: #2CCC4A;
      }

      &.orange {
        background: #FF7C48;;
      }

      &.orange {
        background: #FF7C48;;
        /*background: linear-gradient(360deg, #479DFF 0%, #0068FF 100%);*/
      }
    }

    .part-one {
      height: 698PX;
      box-sizing: border-box;
      .padding-left-12 {
        padding-left: 12PX;
      }
      .left-part-one, .right-part-one {
        height: 94PX;
      }
      .left-part-two, .left-part-three, .right-part-two, .right-part-three, .center-part-two {
        height: 284PX;
      }

      .center-part-one {
        height: 390PX;
      }

      .project-statistics {
        padding: 16PX 0;

        .divide-line {
          width: 1PX;
          height: 50PX;
          background: rgba(255, 255, 255, 0.15);
          margin: 6PX 0;
        }

        .statistics-number {
          font-size: 32PX;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 40PX;
          font-family: Arial !important;
        }

        .statistics-type {
          font-size: 14PX;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          line-height: 22PX;
        }
      }
    }

    .part-two {
      height: 238PX;
      .enter-wrapper {
        padding: 24PX 12PX 0 12PX;
        .enter-box {
          margin-bottom: 16PX;
          cursor: pointer;
          .statistics-icon {
            width: 44PX;
            height: 44PX;
            line-height: 40PX;
            margin: 0 auto;
          }
          .enter-text {
            height: 20PX;
            font-size: 12PX;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 20PX;
            margin-top: 12PX;
            text-align: center;
          }
        }
      }
    }

  }
</style>
